import React, { Fragment, useEffect, useState } from 'react';
import Text from '../../../atoms/text/Text';
import styles from './SingleNewsPage.module.scss';
import { useTranslation } from 'react-i18next';

const CountdownTimer = ({ targetDate, isRtl }) => {
  const { t } = useTranslation();
  const [parts, setParts] = useState({ d: 0, h: 0, m: 0, s: 0, ready: false });

  useEffect(() => {
    if (!targetDate) return;

    const target = new Date(targetDate);
    if (isNaN(target.getTime())) return;

    const tick = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        setParts({ d: 0, h: 0, m: 0, s: 0, ready: true });
        return false;
      }
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((diff % (1000 * 60)) / 1000);
      setParts({ d, h, m, s, ready: true });
      return true;
    };

    let running = tick();
    const interval = setInterval(() => {
      running = tick();
      if (!running) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const items = [
    { value: parts.d, label: 'common.days' },
    { value: parts.h, label: 'common.hours' },
    { value: parts.m, label: 'common.minutes' },
    { value: parts.s, label: 'common.seconds' },
  ];
  const filteredItems = items.filter((it) => it.value !== 0);

  const ordered = filteredItems;
  const sepChar = isRtl ? '،' : ',';
  const isEnded =
    parts.ready &&
    parts.d === 0 &&
    parts.h === 0 &&
    parts.m === 0 &&
    parts.s === 0;
  if (isEnded) return null;
  return (
    <div
      className={`${styles['countdown-timer']} ${isRtl ? styles['countdown-rtl'] : ''}`}
    >
      <Text
        title="time.Countdown"
        variant="text-bold-italic-20"
        className={styles.countdownTitle}
        color="#008755"
      />

      <p className={`${styles.countdownLine}`} dir={isRtl ? 'rtl' : 'ltr'}>
        {ordered.map((it, i) => (
          <span key={i}>
            <span className={`${styles.segment}`}>
              <span className="notranslate">{it.value}</span> {t(it.label)}
            </span>
            {i < ordered.length - 1 && (
              <>
                <span className={styles.sep}>{sepChar}</span>
                {'\u00A0'}
              </>
            )}
          </span>
        ))}
      </p>
    </div>
  );
};

export default React.memo(CountdownTimer);
